// import React from "react";
// import {
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   Button,
//   Typography,
//   Box,
//   Paper,
//   Chip,
//   Divider,
// } from "@mui/material";
// import { Assignment as AssignmentIcon } from "@mui/icons-material";

// const AssignedOrdersDialog = ({ open, onClose, orders = [] }) => {
//   const title = `Assigned Invoice${orders.length !== 1 ? "s" : ""}`;

//   return (
//     <Dialog
//       open={open}
//       onClose={onClose}
//       maxWidth="md"
//       fullWidth
//       PaperProps={{
//         sx: {
//           borderRadius: 3,
//           minHeight: 350,
//           background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
//           overflow: "hidden",
//         },
//       }}
//     >
//       {/* Header Section */}
//       <DialogTitle
//         sx={{
//           background: "rgba(255, 255, 255, 0.95)",
//           backdropFilter: "blur(10px)",
//           borderBottom: "1px solid rgba(255, 255, 255, 0.2)",
//           position: "relative",
//           padding: 3,
//           paddingBottom: 2,
//         }}
//       >
//         <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 1 }}>
//           <Box sx={{ flex: 1 }}>
//             <Typography
//               variant="h5"
//               component="div"
//               sx={{
//                 fontWeight: 600,
//                 color: "#2d3748",
//                 mb: 1,
//               }}
//             >
//               {title}
//             </Typography>
//             <Typography
//               variant="body1"
//               sx={{
//                 color: "#435674ff",
//                 fontWeight: 500,
//               }}
//             >
//               Total invoice{orders.length !== 1 ? "s" : ""}:{" "}
//               <strong style={{ color: "#000000ff", fontSize: "1rem" }}>
//                 {orders.length}
//               </strong>{" "}
//             </Typography>
//           </Box>
//         </Box>
//       </DialogTitle>

//       <DialogContent
//         sx={{ padding: 0, background: "rgba(255, 255, 255, 0.95)" }}
//       >
//         <Box sx={{ p: "8px 24px" }}>
//           {orders.length === 0 ? (
//             <Box
//               sx={{
//                 display: "flex",
//                 flexDirection: "column",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 py: 6,
//                 color: "#718096",
//               }}
//             >
//               <AssignmentIcon sx={{ fontSize: 64, mb: 2, opacity: 0.3 }} />
//               <Typography variant="h6" sx={{ mb: 1, fontWeight: 500 }}>
//                 No Invoice Assigned
//               </Typography>
//               <Typography variant="body2">
//                 There are currently no invoice assigned to display.
//               </Typography>
//             </Box>
//           ) : (
//             <Paper
//               sx={{
//                 maxHeight: 350,
//                 overflowY: "auto",
//                 p: 3,
//                 background: "linear-gradient(135deg, #f7fafc 0%, #edf2f7 100%)",
//                 border: "1px solid rgba(102, 126, 234, 0.2)",
//                 borderRadius: 2,
//                 "&::-webkit-scrollbar": {
//                   width: "8px",
//                 },
//                 "&::-webkit-scrollbar-track": {
//                   background: "rgba(0,0,0,0.1)",
//                   borderRadius: "4px",
//                 },
//                 "&::-webkit-scrollbar-thumb": {
//                   background: "linear-gradient(135deg, #667eea, #764ba2)",
//                   borderRadius: "4px",
//                   "&:hover": {
//                     background: "linear-gradient(135deg, #5a67d8, #6b46c1)",
//                   },
//                 },
//               }}
//               elevation={0}
//             >
//               <Typography
//                 variant="subtitle2"
//                 sx={{
//                   mb: 1,
//                   color: "#4a5568",
//                   fontWeight: 600,
//                   textTransform: "uppercase",
//                   letterSpacing: "0.5px",
//                   fontSize: "0.75rem",
//                 }}
//               >
//                 {`Invoice${orders.length > 1 ? "s" : ""}`}
//               </Typography>
//               <Divider sx={{ mb: 2, background: "rgba(102, 126, 234, 0.2)" }} />
//               <Box
//                 sx={{
//                   display: "flex",
//                   flexWrap: "wrap",
//                   gap: 1.5,
//                   alignItems: "flex-start",
//                 }}
//               >
//                 {orders.map((order, index) => (
//                   <Chip
//                     key={order}
//                     label={order}
//                     sx={{
//                       fontWeight: 600,
//                       fontSize: "0.875rem",
//                       height: 36,
//                       px: 1,
//                       transition: "all 0.2s ease-in-out",
//                       "&:hover": {
//                         transform: "translateY(-2px)",
//                         boxShadow: "0 4px 12px rgba(102, 126, 234, 0.4)",
//                       },
//                     }}
//                   />
//                 ))}
//               </Box>
//             </Paper>
//           )}
//         </Box>
//       </DialogContent>

//       <DialogActions
//         sx={{
//           padding: 3,
//           background: "rgba(255, 255, 255, 0.95)",
//           borderTop: "1px solid rgba(255, 255, 255, 0.2)",
//           justifyContent: "flex-end",
//         }}
//       >
//         <Button
//           onClick={onClose}
//           variant="contained"
//           sx={{
//             fontWeight: 600,
//             px: 2,
//             py: 1,
//             borderRadius: 2,
//             textTransform: "none",
//             fontSize: "1rem",
//             transition: "all 0.2s ease-in-out",
//           }}
//         >
//           Close
//         </Button>
//       </DialogActions>
//     </Dialog>
//   );
// };

// export default AssignedOrdersDialog;


// **************************************************************************************************************************************


import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  Paper,
  Chip,
  Divider,
  Checkbox,
  CircularProgress,
  Autocomplete,
  TextField,
} from "@mui/material";
import { Assignment as AssignmentIcon, DeleteSweep as DeleteSweepIcon } from "@mui/icons-material";
import httpclient from "../../../../Utils";
import { useNotification } from "../../../../Hooks/useNotification";
import { useApiErrorHandler } from "../../../../Hooks/useApiErrorHandler";
import useTokenRefresh from "../../../../Hooks/useTokenRefresh";

const AssignedOrdersDialog = ({
  open,
  onClose,
  orders = [],
  driverId,
  driverName,
  currentInvoicesState,
  currentInvoicesStateColor,
  currentInvoiceDrops,
  currentInvoiceReferences,
  currentInvoiceLines,
  currentInvoicesDeliveryDate,
  onClearOrders,
  onRefreshData,
  allDrivers = [] // Add this prop to receive drivers from parent
}) => {
  const [selectedInvoices, setSelectedInvoices] = useState([]);
  const [showReassignDialog, setShowReassignDialog] = useState(false);
  const [selectedNewDriver, setSelectedNewDriver] = useState("");
  const [actionLoading, setActionLoading] = useState(false);
  const [releaseConfirmOpen, setReleaseConfirmOpen] = useState(false);
  const [reassignConfirmOpen, setReassignConfirmOpen] = useState(false);
  
  const showNotification = useNotification();
  const handleApiError = useApiErrorHandler();
  const { getTokenRefreshed: refresh } = useTokenRefresh();

  const title = `Assigned Invoice${orders.length !== 1 ? "s" : ""}`;

  // Same chip design/show-hide logic as the per-period drops/references/lines
  // chips in the Delivery > Orders driver collapsible section (DriversPanel.js).
  const invoiceSummaryLabel = (() => {
    const drops = currentInvoiceDrops ?? 0;
    const references = currentInvoiceReferences ?? 0;
    const lines = currentInvoiceLines ?? 0;

    if (!drops && !references && !lines) return null;

    const parts = [];
    if (drops) {
      parts.push(`${drops} Drop${drops === 1 ? "" : "s"}/Stop${drops === 1 ? "" : "s"}`);
    }
    parts.push(`${references} Reference${references === 1 ? "" : "s"}`);
    parts.push(`${lines} Line${lines === 1 ? "" : "s"}`);
    return parts.join(", ");
  })();

  // Filter available drivers (exclude current driver and only show active ones)
  const availableDrivers = allDrivers.filter(driver => 
    driver.id !== driverId && driver.status === 1
  );

  // Handle checkbox selection
  const handleCheckboxChange = (jobNo) => {
    setSelectedInvoices(prev => {
      if (prev.includes(jobNo)) {
        return prev.filter(i => i !== jobNo);
      } else {
        return [...prev, jobNo];
      }
    });
  };

  // Select all invoices
  const handleSelectAll = () => {
    if (selectedInvoices.length === orders.length) {
      setSelectedInvoices([]);
    } else {
      setSelectedInvoices(orders.map((order) => order.job_no));
    }
  };

  // Handle Release All button click
  const handleReleaseAllClick = () => {
    onClearOrders(driverId, driverName);
  };

  // Handle Release Selected button click
  const handleReleaseSelectedClick = () => {
    setReleaseConfirmOpen(true);
  };

  // Handle Reassign button click
  const handleReassignClick = () => {
    setShowReassignDialog(true);
    setSelectedNewDriver(""); // Reset selection
  };

  // Confirm Release Selected
  const confirmReleaseSelected = async () => {
    setActionLoading(true);
    
    const formData = new FormData();
    selectedInvoices.forEach(invoice => {
      formData.append('invoices[]', invoice);
    });
    
    const API_URL = `delivery/drivers/invoice/${driverId}/release`;
    
    try {
      const { data } = await httpclient.post(API_URL, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      
      if (data.status === 200) {
        showNotification("success", data.message || "Invoices released successfully");
        setReleaseConfirmOpen(false);
        setSelectedInvoices([]);
        if (onRefreshData) {
          onRefreshData();
        }
        // Close main dialog after a short delay
        setTimeout(() => {
          onClose();
        }, 300);
      } else {
        showNotification("info", data.message || "Failed to release invoices");
        setReleaseConfirmOpen(false);
      }
    } catch (error) {
      if (error.response?.status === 401) {
        refresh();
      } else {
        handleApiError(error);
      }
      setReleaseConfirmOpen(false);
    } finally {
      setActionLoading(false);
    }
  };

  // Confirm Reassign Selected
  const confirmReassignSelected = async () => {
    setActionLoading(true);
    
    const formData = new FormData();
    selectedInvoices.forEach(invoice => {
      formData.append('invoices[]', invoice);
    });
    formData.append('driver_id', selectedNewDriver);
    
    const API_URL = `delivery/drivers/invoice/${driverId}/reassign`;
    
    try {
      const { data } = await httpclient.post(API_URL, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      
      if (data.status === 200) {
        showNotification("success", data.message || "Invoices reassigned successfully");
        setReassignConfirmOpen(false);
        setShowReassignDialog(false);
        setSelectedInvoices([]);
        setSelectedNewDriver("");
        if (onRefreshData) {
          onRefreshData();
        }
        // Close main dialog after a short delay
        setTimeout(() => {
          onClose();
        }, 300);
      } else {
        showNotification("info", data.message || "Failed to reassign invoices");
        setReassignConfirmOpen(false);
      }
    } catch (error) {
      if (error.response?.status === 401) {
        refresh();
      } else {
        handleApiError(error);
      }
      setReassignConfirmOpen(false);
    } finally {
      setActionLoading(false);
    }
  };

  // Custom Confirmation Dialog Component
  const CustomConfirmDialog = ({ open, onClose, title, message, onConfirm, loading }) => (
    <Dialog 
      open={open} 
      onClose={!loading ? onClose : undefined} 
      maxWidth="sm" 
      fullWidth
    >
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Typography sx={{ whiteSpace: "pre-line" }}>{message}</Typography>
      </DialogContent>
      <DialogActions sx={{ p: 2, gap: 1 }}>
        <Button onClick={onClose} variant="outlined" disabled={loading}>
          Cancel
        </Button>
        <Button 
          onClick={onConfirm} 
          variant="contained" 
          color="error"
          disabled={loading}
        >
          {loading ? <CircularProgress size={24} /> : "Confirm"}
        </Button>
      </DialogActions>
    </Dialog>
  );

  return (
    <>
      <Dialog
        open={open}
        onClose={actionLoading ? undefined : onClose}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 3,
            minHeight: 350,
            background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
            overflow: "hidden",
          },
        }}
      >
        <DialogTitle
          sx={{
            background: "rgba(255, 255, 255, 0.95)",
            backdropFilter: "blur(10px)",
            borderBottom: "1px solid rgba(255, 255, 255, 0.2)",
            position: "relative",
            padding: 3,
            paddingBottom: 2,
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 2, mb: 1 }}>
            <Box sx={{ flex: 1 }}>
              <Typography
                variant="h5"
                component="div"
                sx={{
                  fontWeight: 600,
                  color: "#2d3748",
                  mb: 1,
                }}
              >
                {title}{driverName ? ` - ${driverName}` : ""}
              </Typography>
              {/* <Typography
                variant="body1"
                sx={{
                  color: "#435674ff",
                  fontWeight: 500,
                }}
              >
                Total invoice{orders.length !== 1 ? "s" : ""}:{" "}
                <strong style={{ color: "#000000ff", fontSize: "1rem" }}>
                  {orders.length}
                </strong>{" "}
              </Typography> */}
              <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, flexWrap: "wrap" }}>
                {invoiceSummaryLabel && (
                  <Chip
                    size="small"
                    label={invoiceSummaryLabel}
                    sx={{
                      backgroundColor: "#48505E",
                      color: "#fff",
                      fontWeight: 600,
                      height: 22,
                      fontSize: "0.7rem",
                    }}
                  />
                )}
                {currentInvoicesState && (
                  <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                    <Typography
                      variant="body2"
                      sx={{ color: "#435674ff", fontWeight: 500 }}
                    >
                      Status:
                    </Typography>
                    <Chip
                      label={currentInvoicesState}
                      size="small"
                      sx={{
                        backgroundColor: currentInvoicesStateColor || "#9E9E9E",
                        color: "#fff",
                        fontWeight: 600,
                      }}
                    />
                  </Box>
                )}
                {currentInvoicesDeliveryDate && (
                  <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                    <Typography
                      variant="body2"
                      sx={{ color: "#435674ff", fontWeight: 500 }}
                    >
                      Delivery Date:
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{ color: "#000000ff", fontWeight: 600 }}
                    >
                      {currentInvoicesDeliveryDate}
                    </Typography>
                  </Box>
                )}
              </Box>
            </Box>
            
            {orders.length > 0 && (
              <Button
                onClick={handleReleaseAllClick}
                variant="outlined"
                color="error"
                startIcon={<DeleteSweepIcon />}
                disabled={actionLoading}
                sx={{
                  fontWeight: 600,
                  px: 2,
                  py: 1,
                  borderRadius: 2,
                  textTransform: "none",
                  fontSize: "0.875rem",
                  transition: "all 0.2s ease-in-out",
                  borderColor: "#d32f2f",
                  color: "#d32f2f",
                  whiteSpace: "nowrap",
                  "&:hover": {
                    borderColor: "#b71c1c",
                    backgroundColor: "rgba(211, 47, 47, 0.04)",
                  },
                }}
              >
                Release All Invoices
              </Button>
            )}
          </Box>
        </DialogTitle>

        <DialogContent
          sx={{ padding: 0, background: "rgba(255, 255, 255, 0.95)" }}
        >
          <Box sx={{ p: "8px 24px" }}>
            {orders.length === 0 ? (
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  py: 6,
                  color: "#718096",
                }}
              >
                <AssignmentIcon sx={{ fontSize: 64, mb: 2, opacity: 0.3 }} />
                <Typography variant="h6" sx={{ mb: 1, fontWeight: 500 }}>
                  No Invoice Assigned
                </Typography>
                <Typography variant="body2">
                  There are currently no invoice assigned to display.
                </Typography>
              </Box>
            ) : (
              <Paper
                sx={{
                  maxHeight: 350,
                  overflowY: "auto",
                  p: 3,
                  background: "linear-gradient(135deg, #f7fafc 0%, #edf2f7 100%)",
                  border: "1px solid rgba(102, 126, 234, 0.2)",
                  borderRadius: 2,
                  "&::-webkit-scrollbar": {
                    width: "8px",
                  },
                  "&::-webkit-scrollbar-track": {
                    background: "rgba(0,0,0,0.1)",
                    borderRadius: "4px",
                  },
                  "&::-webkit-scrollbar-thumb": {
                    background: "linear-gradient(135deg, #667eea, #764ba2)",
                    borderRadius: "4px",
                    "&:hover": {
                      background: "linear-gradient(135deg, #5a67d8, #6b46c1)",
                    },
                  },
                }}
                elevation={0}
              >
                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 1 }}>
                  <Typography
                    variant="subtitle2"
                    sx={{
                      color: "#4a5568",
                      fontWeight: 600,
                      textTransform: "uppercase",
                      letterSpacing: "0.5px",
                      fontSize: "0.75rem",
                    }}
                  >
                    {`Invoice${orders.length > 1 ? "s" : ""}`}
                  </Typography>

                  {orders.length > 0 && (
                    <Button
                      size="small"
                      onClick={handleSelectAll}
                      disabled={actionLoading}
                      sx={{ textTransform: "none", fontSize: "0.75rem" }}
                    >
                      {selectedInvoices.length === orders.length ? "Deselect All" : "Select All"}
                    </Button>
                  )}
                </Box>
                <Divider sx={{ mb: 2, background: "rgba(102, 126, 234, 0.2)" }} />
                <Box
                  sx={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: 1.5,
                    alignItems: "flex-start",
                  }}
                >
                  {orders.map((order) => {
                    const isSelected = selectedInvoices.includes(order.job_no);
                    const hasColor = Boolean(order.job_color);
                    return (
                      <Box
                        key={order.job_no}
                        sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 0.5 }}
                      >
                        <Chip
                          label={order.job_no}
                          icon={
                            <Checkbox
                              size="small"
                              checked={isSelected}
                              onChange={() => handleCheckboxChange(order.job_no)}
                              onClick={(e) => e.stopPropagation()}
                              disabled={actionLoading}
                              sx={{
                                "& .MuiSvgIcon-root": {
                                  fontSize: "20px",
                                  color: isSelected && hasColor ? "#fff" : undefined,
                                },
                              }}
                            />
                          }
                          sx={{
                            fontWeight: 600,
                            fontSize: "0.875rem",
                            height: 36,
                            px: 0.5,
                            transition: "all 0.2s ease-in-out",
                            color: isSelected && hasColor ? "#fff" : undefined,
                            ...(isSelected && hasColor
                              ? {
                                  backgroundColor: order.job_color,
                                  borderColor: order.job_color,
                                }
                              : {}),
                            "&:hover": {
                              transform: "translateY(-2px)",
                              boxShadow: "0 4px 12px rgba(102, 126, 234, 0.4)",
                            },
                          }}
                          variant={isSelected ? "filled" : "outlined"}
                          color={isSelected && !hasColor ? "primary" : "default"}
                        />
                        {order.job_title && (
                          <Typography
                            sx={{
                              fontSize: "0.7rem",
                              fontWeight: 500,
                              color: hasColor ? order.job_color : "#718096",
                              textAlign: "center",
                            }}
                          >
                            {order.job_title}
                          </Typography>
                        )}
                      </Box>
                    );
                  })}
                </Box>
              </Paper>
            )}
          </Box>
        </DialogContent>

        <DialogActions
          sx={{
            padding: 3,
            background: "rgba(255, 255, 255, 0.95)",
            borderTop: "1px solid rgba(255, 255, 255, 0.2)",
            justifyContent: "space-between",
          }}
        >
          <Box sx={{ display: "flex", gap: 2 }}>
            {selectedInvoices.length > 0 && (
              <>
                <Button
                  onClick={handleReleaseSelectedClick}
                  variant="outlined"
                  color="error"
                  disabled={actionLoading}
                  sx={{
                    fontWeight: 600,
                    px: 2,
                    py: 1,
                    borderRadius: 2,
                    textTransform: "none",
                    fontSize: "0.875rem",
                  }}
                >
                  Release Invoices ({selectedInvoices.length})
                </Button>
                
                <Button
                  onClick={handleReassignClick}
                  variant="outlined"
                  color="primary"
                  disabled={actionLoading || availableDrivers.length === 0}
                  sx={{
                    fontWeight: 600,
                    px: 2,
                    py: 1,
                    borderRadius: 2,
                    textTransform: "none",
                    fontSize: "0.875rem",
                  }}
                >
                  Reassign Invoices ({selectedInvoices.length})
                </Button>
              </>
            )}
          </Box>
          
          <Button
            onClick={onClose}
            variant="contained"
            disabled={actionLoading}
            sx={{
              fontWeight: 600,
              px: 2,
              py: 1,
              borderRadius: 2,
              textTransform: "none",
              fontSize: "1rem",
              transition: "all 0.2s ease-in-out",
            }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>

      {/* Custom Confirmation Dialog for Release Selected */}
      <CustomConfirmDialog
        open={releaseConfirmOpen}
        onClose={() => !actionLoading && setReleaseConfirmOpen(false)}
        title="Release Invoices"
        message={`Are you sure you want to release ${selectedInvoices.length} invoice${selectedInvoices.length !== 1 ? "s" : ""} from driver ${driverName}?\n\nInvoices: ${selectedInvoices.join(", ")}`}
        onConfirm={confirmReleaseSelected}
        loading={actionLoading}
      />

      {/* Reassign Dialog with Driver Selection - Instant load from props */}
      <Dialog
        open={showReassignDialog}
        onClose={() => !actionLoading && setShowReassignDialog(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Reassign Invoices</DialogTitle>
        <DialogContent>
          <Box sx={{ mt: 2 }}>
            <Typography variant="body2" sx={{ mb: 2 }}>
              Reassign <strong>{selectedInvoices.length}</strong> invoice{selectedInvoices.length !== 1 ? "s" : ""} to a different driver:
            </Typography>
            <Typography variant="body2" sx={{ mb: 2, color: "#666" }}>
              Invoices: {selectedInvoices.join(", ")}
            </Typography>
            
            <Autocomplete
              fullWidth
              disabled={actionLoading}
              options={availableDrivers}
              getOptionLabel={(driver) => `${driver.full_name}- ${driver.user_name}`}
              value={availableDrivers.find((d) => d.id === selectedNewDriver) || null}
              onChange={(_, newValue) => setSelectedNewDriver(newValue ? newValue.id : "")}
              noOptionsText="No other drivers available"
              renderInput={(params) => (
                <TextField {...params} label="Select Driver" placeholder="Search driver" />
              )}
            />
          </Box>
        </DialogContent>
        <DialogActions sx={{ p: 2, gap: 1 }}>
          <Button 
            onClick={() => setShowReassignDialog(false)}
            variant="outlined"
            disabled={actionLoading}
          >
            Cancel
          </Button>
          <Button
            onClick={() => setReassignConfirmOpen(true)}
            variant="contained"
            disabled={!selectedNewDriver || actionLoading}
            color="primary"
          >
            Next
          </Button>
        </DialogActions>
      </Dialog>

      {/* Custom Confirmation Dialog for Reassign */}
      <CustomConfirmDialog
        open={reassignConfirmOpen}
        onClose={() => !actionLoading && setReassignConfirmOpen(false)}
        title="Reassign Invoices"
        message={`Are you sure you want to reassign ${selectedInvoices.length} invoice${selectedInvoices.length !== 1 ? "s" : ""} from ${driverName} to ${availableDrivers.find(d => d.id === selectedNewDriver)?.full_name || "selected driver"}?\n\nInvoices: ${selectedInvoices.join(", ")}`}
        onConfirm={confirmReassignSelected}
        loading={actionLoading}
      />
    </>
  );
};

export default AssignedOrdersDialog;